import { Map } from 'immutable';
/**
 * Type guard to check if an object is an Immutable.js Map
 */
export function isImmutableMap(obj) {
  return Map.isMap(obj);
}

/**
 * Helper to safely get a value from either an Immutable Map or plain object
 */
export function getValue(obj, key) {
  if (!obj) return undefined;
  if (isImmutableMap(obj)) {
    return obj.get(key);
  }
  if (typeof obj === 'object' && obj !== null) {
    return obj[key];
  }
  return undefined;
}